import { cloneTemplate, setTableRowValues } from '../../shared/dom-template';
import { formatCurrency } from '../../pledge-pay/pledge-pay-utils.js';
import { realMemberIdOrEmpty } from '../../shared/default-member-id.js';

export default function createPledgesPaymentTableHelpers() {
    function mapPaymentsAndTotals(rawPayments) {
        const round2 = (n) => Math.round(n * 100) / 100;
        let amt_total = 0;
        let surcharge_total = 0;
        let grand_total = 0;
        const payments = [];
        rawPayments.forEach(function (input) {
            const mgrSetPaidNotes = input.mgr_set_paid_notes ?? '';
            const referenceValue = input.auth_code !== null ? input.auth_code : mgrSetPaidNotes;
            const originallyOpen = !!input.originally_open;
            const rawSurcharge = parseFloat(input.surcharge_amount) || 0;
            const rowSurcharge = originallyOpen ? 0 : round2(rawSurcharge);
            const rowAmount = round2(parseFloat(input.amount) || 0);
            const rowTotal = round2(rowAmount + rowSurcharge);
            payments.push({
                originally_open: originallyOpen,
                is_manual: !!input.is_manual,
                card_method: input.card_method || null,
                card_type: input.card_type || null,
                card_last_four: input.card_last_four || null,
                payment_method: originallyOpen ? 'open_credit' : null,
                date: window.convert_date(input.created_at),
                reference: referenceValue || '—',
                amount: '$' + formatCurrency(rowAmount),
                surcharge: rowSurcharge > 0 ? '$' + formatCurrency(rowSurcharge) : 'N/A',
                total: '$' + formatCurrency(rowTotal),
                method_chip_html: input.method_chip_html || '',
                gridRowId: input.id ? 'pp-' + String(input.id) : '',
            });
            amt_total = round2(amt_total + rowAmount);
            surcharge_total = round2(surcharge_total + rowSurcharge);
            grand_total = round2(grand_total + rowTotal);
        });
        const totalsSurcharge = surcharge_total === 0 ? 'N/A' : '$' + formatCurrency(surcharge_total);
        const totalsGrand = surcharge_total === 0 ? '$' + formatCurrency(amt_total) : '$' + formatCurrency(grand_total);
        return {
            payments,
            totals: {
                amount: '$' + formatCurrency(amt_total),
                surcharge: totalsSurcharge,
                total: totalsGrand,
                amountRaw: amt_total,
                surchargeRaw: surcharge_total,
                grandTotalRaw: grand_total,
            },
        };
    }

    function createPaymentsTableElement(payments, totals, options) {
        const linkToTransactions = options?.linkToTransactions ?? false;
        const memberId = realMemberIdOrEmpty(options?.memberId);
        const $table = cloneTemplate('tpl-recur-payments-table');
        if (!$table) {
            return $('<div>');
        }
        if (payments.length === 1) {
            $table.addClass('recur-payments-table--single');
        }
        const $tbody = $table.find('tbody');
        payments.forEach(function (payment) {
            const $row = cloneTemplate('tpl-recur-payments-row');
            if (!$row) {
                return;
            }
            setTableRowValues($row, [
                payment.date,
                payment.reference,
                payment.amount,
                payment.surcharge,
                payment.total,
                '',
            ]);
            const $methodCell = $row.find('td').eq(5);
            if (payment.method_chip_html) {
                $methodCell.html(payment.method_chip_html);
            } else {
                $methodCell.text('—');
            }
            if (linkToTransactions && payment.gridRowId) {
                $row.addClass('recur-payments-row--clickable');
                const rowAttrs = {
                    'data-row-id': payment.gridRowId,
                    role: 'button',
                    tabindex: '0',
                    title: 'View in Transactions',
                };
                if (memberId) {
                    rowAttrs['data-member-id'] = memberId;
                }
                $row.attr(rowAttrs);
            }
            $tbody.append($row);
        });
        const $totalsRow = cloneTemplate('tpl-recur-payments-totals-row');
        if ($totalsRow) {
            setTableRowValues($totalsRow, ['Totals', '', totals.amount, totals.surcharge, totals.total, '']);
            $tbody.append($totalsRow);
        }
        return $table;
    }

    return {
        mapPaymentsAndTotals,
        createPaymentsTableElement,
    };
}
